import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { COLLAPSED_SPORTS_PATH, SORT_BY_START_TIME, SORT_BY_TOURNAMENTS } from './constants';
import { Map, Set } from 'immutable';
import { MatchIdentity } from './dto';
import { matchVisible, sportKey } from './utils';

export const allMatchIds$ = pathSubscription(['turboLive', 'allMatchIds']);
export const filterSport$ = pathSubscription(['turboLive', 'filter', 'sport']);
export const sortBy$ = pathSubscription(['turboLive', 'sortBy'], SORT_BY_TOURNAMENTS);
export const overviewScrollY$ = pathSubscription(['turboLive', 'overviewScrollY'], 0);
export const scrollTop$ = pathSubscription(['turboLive', 'scrollTop'], 0);
export const ticketTabMark$ = pathSubscription(['turboLive', 'detail', 'ticketTabMark'], 0);
export const detailMiniScoreVisible$ = pathSubscription(['turboLive', 'detail', 'miniScoreVisible'], false);
export const detailMiniTimerVisible$ = pathSubscription(['turboLive', 'detail', 'miniDetailVisible'], false);
export const analysisTabMark$ = pathSubscription(['turboLive', 'detail', 'analysisTabMark'], false);
//TODO refactor move to common/h&s.ts
export const loggedIn$ = pathSubscription(['loggedIn'], false);

export const filterStream$ = pathSubscription(['turboLive', 'filter', 'stream'], false);
export const filterRadar$ = pathSubscription(['turboLive', 'filter', 'radar'], false);
export const filterShowCashin$ = pathSubscription(['turboLive', 'filter', 'showCashin']);

const collapsedSports$ = pathSubscription(COLLAPSED_SPORTS_PATH, Set());

export const sportCollapsed$$ = parametric((sportName: string, key: string) =>
    subscription(collapsedSports => (key ? collapsedSports.has(sportKey(sportName, key)) : false), collapsedSports$)
);

export const tournamentVisibilityCustom$$ = parametric((tournamentId, sportName) =>
    subscription(
        ids => ids && ids?.has(tournamentId),
        pathSubscription(['turboLive', 'collapsedTournaments', sportName, 'customTournamentsIds'], false)
    )
);

export const allVisibleMatches$ = subscription(
    (allMatchIds: Map<string, MatchIdentity>, filterRadar: boolean, filterStream: boolean) =>
        allMatchIds?.size
            ? allMatchIds.filter(({ radar, video }) => matchVisible(radar, filterRadar, video, filterStream))
            : Map(),
    allMatchIds$,
    filterRadar$,
    filterStream$
);

export const allTournamentsCollapsed$$ = sportName =>
    pathSubscription(['turboLive', 'collapsedTournaments', sportName, 'collapsedAll'], false);

export const activeFiltersCount$ = subscription(
    (radar, stream) => [radar, stream].filter(Boolean).length,
    filterRadar$,
    filterStream$
);

export const activeResetFilter$ = subscription(
    (loggedIn, showCashin, activeFiltersCount, sortBy) =>
        [loggedIn && !showCashin, activeFiltersCount, sortBy === SORT_BY_START_TIME].filter(Boolean).length > 0,
    loggedIn$,
    filterShowCashin$,
    activeFiltersCount$,
    sortBy$
);
